import useSWR from "swr"
import { API_BASE_URL } from "../../config"
import fetcher from "../../utilities/fetcher"

const usePendingAssignments = (assetUuid) => {
    const { data, error, mutate } = useSWR(() => `${API_BASE_URL}/blockchain/assets/${assetUuid}/assignments`, fetcher)

    return {
        pendingAssignments: (data || []).filter(assignment => !assignment.isDistributed),
        pendingAssignmentsLoading: !error && !data,
        pendingAssignmentsError: error,
        updatePendingAssignments: () => mutate()
    }
}

export default usePendingAssignments